import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Accounts/RetentionSettings/**`. */
const RetentionNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="RETENTION_SETTINGS_UPDATED"
				title="Durées enregistrées"
				message="Les durées de conservation ont été enregistrées."
			/>
			<ErrorNotification
				eventName="RETENTION_SETTINGS_UPDATE_FAILED"
				title="Erreur"
				message="Les durées de conservation n'ont pas pu être enregistrées."
			/>
		</React.Fragment>
	);
};

export default RetentionNotifications;
